module.exports = __webpack_public_path__ + "img/logo.e178999d.png";